import React, { useEffect, useState } from "react";
import AuthLayout from "../components/AuthLayout";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ForgotPasswordForm from "../components/ForgotPasswordForm";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";
import { PORTAL } from "../utils/constant";
import { ClearForgotDataSuccess } from "../store/actions/exampleAction";

function ForgotPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleButtonClick = () => {
    navigate(PORTAL);
  };

  const handleBackButtonClick = () => {
    window.location.href = "https://dev-camu.devopsdemo.live/front/login";
  };

  useEffect(() => {
    return () => {
      dispatch(ClearForgotDataSuccess());
    };
  }, [dispatch]);
  const ForgotSuccess = useSelector((state) => state);
  return (
    <div>
      <AuthLayout
        imageTitle={t("WelcomtoLogin")}
        imageSubtitle={t("loginToAccessPortal")}
        buttonName={t("login")}
        accountMsg={t("alreadyAccount")}
        buttonClick={handleButtonClick}
        backButtonClick={handleBackButtonClick}
      >
        {/* <ForgotPasswordForm /> */}
        {!!ForgotSuccess?.profileReducer?.forgotResponseData?.resetPassword ? (
          // {!!SignUpSuccess?.profileReducer?.signUpResponseData?.success ? (
          <Grid className="container ">
            {!!ForgotSuccess?.profileReducer?.forgotResponseData?.resetPassword
              ?.success ? (
              <Grid item xs={12} className="centered-div gutterBottom ">
                <Typography
                  className="mb-2"
                  variant="h6"
                  sx={{ fontWeight: "bold" }}
                >
                  {t("forgotTitle")}
                </Typography>
                <Typography variant="body1" className="mb-2">
                  {t("forgotProgressMessage")}
                </Typography>
                <Typography variant="body1" className="mb-2">
                  {t("forgotMsg")}
                </Typography>
              </Grid>
            ) : (
              <Grid item xs={12} className="centered-div gutterBottom ">
                <Typography
                  className="mb-2"
                  variant="h6"
                  color="error"
                  sx={{ fontWeight: "bold" }}
                >
                  {t("ForgotPasswordFail")}
                </Typography>
              </Grid>
            )}
          </Grid>
        ) : (
          <ForgotPasswordForm />
        )}
      </AuthLayout>
    </div>
  );
}

export default ForgotPassword;
